import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse
} from '../../../constants'
import Fetcher from '../../../services/Fetcher'
import {
  TDashboardFiltersOptionsParams,
  TDashboardFiltersResponse
} from '../types'

const fetcher = new Fetcher({})

export const getLedByOptions = (params?: TDashboardFiltersOptionsParams) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.LED_BY}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getHSOptions = (params?: TDashboardFiltersOptionsParams) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HEALTH_SYSTEM}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getHospitalOptions = (params?: TDashboardFiltersOptionsParams) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.HOSPITAL}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getUserOptions = (params?: TDashboardFiltersOptionsParams) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.USER}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getPortfolioOptions = (params?: TDashboardFiltersOptionsParams) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.PORTFOLIO}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getContractCategoriesOptions = (
  params?: TDashboardFiltersOptionsParams
) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SAVINGS_GOAL}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.CONTRACT_CATEGORY}`,
    method: HTTP_METHODS.GET,
    params
  })

export const applyFiltersRequest = (params?: TDashboardFiltersResponse) =>
  fetcher.request<unknown, TDashboardFiltersResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.FILTERS}`,
    method: HTTP_METHODS.POST,
    data: params
  })

export const updateFiltersRequest = (params?: TDashboardFiltersResponse) =>
  fetcher.request<unknown, TDashboardFiltersResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.FILTERS}`,
    method: HTTP_METHODS.PUT,
    data: params
  })

export const getFiltersRequest = () =>
  fetcher.request<unknown, TDashboardFiltersResponse>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.FILTERS}`,
    method: HTTP_METHODS.GET
  })

export const removeFiltersRequest = () =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.DASHBOARD}${API_DICTIONARY.FILTERS}`,
    method: HTTP_METHODS.DELETE
  })
